import { REDIRECT, RedirectAction, RouteInfo, SET_ROUTE_INFO, SetRouteInfoAction } from './types';

export const redirect = (url: string | undefined): RedirectAction => ({ type: REDIRECT, payload: { url } });
export const setRouteInfo = (info: RouteInfo): SetRouteInfoAction => ({ type: SET_ROUTE_INFO, payload: { info } });
